import React from 'react';
import { ChipProps } from '@material-ui/core';
import { CancelIcon } from 'components/icons/cancel';


export const chipProps: ChipProps = {
  clickable: true,
  deleteIcon: (<CancelIcon />),
};
